export const formatHtmlToCSV = (inputHtml) => {
  if (!inputHtml) {
    return "";
  }
  let result = "";
  let listItemCount = 0;
  const parser = new DOMParser();
  const doc = parser.parseFromString(inputHtml, "text/html");

  const formatNode = (node) => {
    if (!node) return;

    switch (node.nodeType) {
      case Node.ELEMENT_NODE:
        formatElement(node);
        break;
      case Node.TEXT_NODE:
        if (node.textContent.trim()) {
          result += node.textContent.trim() + " ";
        }
        break;
      default:
        Array.from(node.childNodes).forEach(formatNode);
    }
  };

  const formatElement = (node) => {
    switch (node.nodeName.toLowerCase()) {
      case "br":
        result += "\r\n";
        break;
      case "p":
        Array.from(node.childNodes).forEach(formatNode);
        result += "\r\n";
        break;
      case "ul":
      case "ol":
        listItemCount = 0;
        Array.from(node.childNodes).forEach(formatNode);
        break;
      case "li":
        listItemCount++;
        if (!result.endsWith("\r\n")) {
          result += "\r\n";
        }
        result += `${listItemCount}) `;
        Array.from(node.childNodes).forEach(formatNode);
        break;
      default:
        Array.from(node.childNodes).forEach(formatNode);
    }
  };

  formatNode(doc.body);
  var inputdata = result.trim().split(/\.\s+/);
  result = inputdata.join(".\r\n").trim();
  result = result.replace(/(<([^>]+)>)/gi, "");
  result = result.replace(/&nbsp;/g, " ");
  return result.trim();
};
